import GeaoFooter from "./GeaoFooter";

export default function KickoutLayout({
    children,
    header,
    icon
}) {
    return (
        <main id="wrapper" >
            <a data-onboarding-link-id="shared:Layout:KickoutLayout:SkipToMainContent" className="skip-to-content" href="#wrapper">Skip to main content</a>
            <header id="primary-header" role="banner">
                <div className="header-logo">
                    <a data-onboarding-link-id="shared:Layout:KickoutLayout:Home" href="/">
                        <img className="companyLogo pl-2" data-tenant-branding-logo="true" src="https://aadcdn.msftauthimages.net/dbd5a2dd-m7upushe63t5mro-qoncxx7g0ffd-q0du4joa4qyehc/logintenantbranding/0/bannerlogo?ts=638435352267202102" alt="Company Logo" />
                    </a>
                </div>
            </header>
            <div className="content">
                {header &&
                    <div className="page-header--wrapper">
                        <div className="container">
                            <div className="page-header page-header--without-subheader">
                                <div className="page-header-left">
                                    <h2>{header}</h2>
                                </div>
                                {icon && (
                                    <div className="page-header-right">
                                        <span className={`geico-icon ${icon} pull-right`}></span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                }
                <div className="margin-top mx-auto">
                    {children}
                </div>
            </div>
            <GeaoFooter />
        </main>
    );
};
